import React from 'react';
import { useTranslation } from 'react-i18next';

import { RequestFormViewProps } from '../../request-form.types';
import { CandidateLocationSection } from '../candidate-location-section';
import { CommentSection } from '../comment-section';
import { ConditionsSection } from '../conditions-section';
import { EmploymentLocationSection } from '../employment-location-section';
import { GeneralSection } from '../general-section';
import { LanguagesSection } from '../languages-section';
import { SalarySection } from '../salary-section';
import * as Styled from './desktop-view.styles';

const DesktopView: React.FC<RequestFormViewProps> = ({ isNonBillableWarningToBeShown, ...props }) => {
  const { t } = useTranslation();
  const { disabled } = props;

  return (
    <Styled.FormContainer>
      {isNonBillableWarningToBeShown ? (
        <Styled.NonBillableWarning>
          <Styled.AlertIcon type="u_alert_circle_filled" viewBox="0 0 24 24" isPointer />
          {t('pages.requests.nonBillableRequestWillGoApproval')}
        </Styled.NonBillableWarning>
      ) : null}
      <GeneralSection {...props} />
      <EmploymentLocationSection {...props} />
      <CandidateLocationSection />
      <LanguagesSection />
      <SalarySection disabled={disabled} />
      <ConditionsSection {...props} />
      <CommentSection disabled={disabled} />
    </Styled.FormContainer>
  );
};

export default DesktopView;
